import { createFileRoute } from '@tanstack/react-router';

import { getLocalizedTitle } from '../title';

export const Route = createFileRoute('/_app/users/add')({
  head: () => ({
    meta: [{ title: getLocalizedTitle('users.add_user.page_title', 'Add user') }],
  }),
});
